// DNA Automotive · Finanzierungs-Utility
// Zentrale Berechnungsparameter, im Backend/Admin später überschreibbar.

export const FINANCE_DEFAULTS = {
  annualRate: 4.9,     // % p.a., Santander-Standard
  termMonths: 60,      // 60 Monate = 5 Jahre
  downPct: 0.15,       // 15 % Anzahlung
  balloonPct: 0.30,    // 30 % Schlussrate
  minDown: 2000,       // mind. 2 000 € Anzahlung
  partner: "Santander Consumer Bank",
};

/**
 * Klassische Ballon-Finanzierung (Annuität mit Restwert).
 * Monatsrate = (PV - B*(1+i)^-n) * i / (1 - (1+i)^-n)
 * @param {number} price   Fahrzeugpreis
 * @param {object} opts    { down, term, balloon, annualRate }
 * @returns {object}       { rate, financingAmount, total, ...opts }
 */
export function calcMonthlyRate(price, opts = {}) {
  const annualRate = opts.annualRate ?? FINANCE_DEFAULTS.annualRate;
  const term = opts.term ?? FINANCE_DEFAULTS.termMonths;
  const down = opts.down ?? Math.max(FINANCE_DEFAULTS.minDown, Math.round((price * FINANCE_DEFAULTS.downPct) / 100) * 100);
  const balloon = opts.balloon ?? Math.round((price * FINANCE_DEFAULTS.balloonPct) / 100) * 100;

  const financingAmount = Math.max(0, price - down);
  const i = annualRate / 100 / 12;
  let rate;
  if (i === 0) {
    rate = (financingAmount - balloon) / term;
  } else {
    const factor = Math.pow(1 + i, -term);
    rate = ((financingAmount - balloon * factor) * i) / (1 - factor);
  }
  rate = Math.max(0, rate);
  const total = down + rate * term + 0; // balloon paid off separately at end -> included in loan
  const totalRepayment = rate * term + balloon;
  return {
    rate: Math.round(rate),        // gerundet auf ganze €
    financingAmount,
    down,
    balloon,
    term,
    annualRate,
    partner: FINANCE_DEFAULTS.partner,
    totalRepayment: Math.round(totalRepayment),
    totalCost: Math.round(down + totalRepayment),
  };
}

export const fmtEUR = (n) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);
